export default "__VITE_ASSET__TcybNx0A__"